/**
 * ConnectPrompt — inline prompt shown when an unauthenticated user
 * attempts an action that requires a wallet connection.
 */

import { useRequireAuth } from "../../hooks/use-require-auth";
import { Button } from "../ui/Button";

type ConnectPromptProps = {
	message?: string;
};

export function ConnectPrompt({ message = "Connect your wallet to continue" }: ConnectPromptProps) {
	const { isAuthenticated, promptConnect } = useRequireAuth();

	if (isAuthenticated) {
		return null;
	}

	return (
		<div className="flex flex-col items-center gap-4 rounded-xl border border-pastel-border bg-pastel-white p-8 text-center shadow-pastel-sm">
			<p className="text-sm text-pastel-gray">{message}</p>
			<Button variant="gradient" onClick={promptConnect}>
				Connect Wallet
			</Button>
		</div>
	);
}
